import { isAxiosError } from 'axios';

import type { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export const resolveTaskCommentDeleteError = (error: unknown, fallback: string): string => {
    if (isAxiosError<IDataResponseError>(error)) {
        const data = error.response?.data;
        const titles = Array.isArray(data?.errors)
            ? data.errors.flatMap((item) =>
                typeof item?.title === 'string' && item.title.trim() ? [item.title.trim()] : [])
            : [];
        if (titles.length) return titles.join('\n');

        return typeof data?.message === 'string' && data.message.trim()
            ? data.message.trim()
            : fallback;
    }

    return error instanceof Error ? error.message.trim() || fallback : fallback;
};
